import { render, staticRenderFns } from "./HelloPeterAddProfileDialog.vue?vue&type=template&id=2715fad6&scoped=true"
import script from "./HelloPeterAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./HelloPeterAddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./HelloPeterAddProfileDialog.vue?vue&type=style&index=0&id=2715fad6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715fad6",
  null
  
)

export default component.exports